import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiChecklist2ImportService } from './fi-checklist2-import.service';
import { FiChecklist2ImportComponent } from './fi-checklist2-import/fi-checklist2-import.component';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { MatIconModule } from '@angular/material/icon';
import { FiInsertMediaModule } from '@fi-shared/fi-insert-media/fi-insert-media.module';
import { FiTooltipModule } from '@fi-shared/fi-tooltip/fi-tooltip.module';
import { FiChecklist2ImportTextsService } from '@fi-shared/checklist/fi-checklist2-shared/fi-checklist2-import-texts.service';

@NgModule({
    imports: [CommonModule, FiAppTextSharedModule, MatIconModule, FiInsertMediaModule, FiTooltipModule],
    declarations: [FiChecklist2ImportComponent],
    providers: [FiChecklist2ImportService, FiChecklist2ImportTextsService],
    exports: [FiChecklist2ImportComponent],
})
export class FiChecklist2SharedModule {}
